import { Button, Divider, Flex, Typography } from "antd"
import cn from "classnames"

import Icon from "../../../../Icon"

import "../../styles.less"

const { Text } = Typography

const OnboardingStepItem = ({
  id,
  step,
  title,
  description,
  handleContinue,
  handleOpenModal = () => {},
  verifyButtonState = {},
  isVerify = false,
  isDivider = false,
  isComlete = false,
  isContinue = false,
  isEdit = false,
  isDisabledContinue = false
}) => {
  return (
    <div>
      <Flex className="onboarding_step_item" justify="space-between" align="center">
        <Flex gap={12} align="center">
          <Flex
            className={cn("step", {
              complete: isComlete,
              first: !isComlete && isEdit && id === 1
            })}
            align="center"
            justify="center"
          >
            {isComlete ? <Icon type="check_full" style={{ color: "#006908" }} /> : id}
          </Flex>
          <div>
            <div className="title">{title}</div>
            <Flex align="center">
              <Text type="secondary">{description}</Text>
              {isEdit && !isComlete && (
                <Button
                  type="text"
                  style={{ width: 20, height: 20 }}
                  icon={<Icon type="edit_small" className="editIcon" />}
                  onClick={() => handleOpenModal("form")}
                />
              )}
            </Flex>
          </div>
        </Flex>
        {isVerify && !isComlete && (
          <div>
            <Button disabled={verifyButtonState.disabled} onClick={() => handleOpenModal("sent")}>
              Verify
            </Button>
          </div>
        )}
        {isContinue && (
          <div>
            <Button disabled={isDisabledContinue} onClick={() => handleContinue(step)}>
              Continue
            </Button>
          </div>
        )}
      </Flex>
      {isDivider && (
        <Flex gap={12}>
          <div style={{ width: 32 }} />
          <Divider style={{ flex: 1, minWidth: 20, margin: "16px 0" }} />
        </Flex>
      )}
    </div>
  )
}

export default OnboardingStepItem
